var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col order-1 order-lg-2" }, [
          _vm.live_start_date && _vm.showDate && _vm.isFutureDate
            ? _c("div", { staticClass: "row mt-3" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm._f("translate")("This event starts in")) + ":"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 col-lg-4 mx-auto" },
                  [_c("CountdownTime", { attrs: { date: _vm.date } })],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.course.live_show_additional_message
            ? _c("div", { staticClass: "row my-3" }, [
                _vm.course.live_message
                  ? _c("div", {
                      staticClass: "col-12 col-md-6 col-lg-4 mx-auto",
                      domProps: {
                        innerHTML: _vm._s(_vm.course.live_message.html),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-12",
                  domProps: {
                    innerHTML: _vm._s(_vm.course.live_additional_html),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasAccess
            ? _c("div", { staticClass: "row mt-3" }, [
                _vm.live_video_embed_url
                  ? _c("div", { staticClass: "col-lg-9 mx-auto" }, [
                      _c("div", { staticClass: "ratio ratio-16x9" }, [
                        _c("iframe", {
                          attrs: {
                            src: _vm.live_video_embed_url,
                            frameborder: "0",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture",
                            allowfullscreen: "",
                          },
                        }),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.live_chat_embed_url
                  ? _c(
                      "div",
                      {
                        staticClass: "col-lg-3",
                        staticStyle: { "min-height": "400px" },
                      },
                      [
                        _c("iframe", {
                          attrs: {
                            src: _vm.live_chat_embed_url,
                            width: "100%",
                            height: "100%",
                            frameborder: "0",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ])
            : _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12 text-center" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary m-3",
                        attrs: {
                          href: `/${_vm.$route.params.course}/checkout`,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("translate")("Enroll")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: `/${_vm.$route.params.course}/watch/login`,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("translate")("Sign in")) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c("PasswordLogin", { ref: "passwordLogin" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }